// extracted by mini-css-extract-plugin
var _1 = "InputResizerHandlers_root__ecd7a";
var _2 = "InputResizerHandlers_visible__023f7";
export { _1 as "root", _2 as "visible" }
